/// <reference path="../../../typings/index.d.ts" />
angular
    .module('app')
    .factory('ConnectedUserService', function ($http, $q, UserServiceApi) {
    let connectedUser = null;
    let perms = null;
    let fac = {
        set: set,
        get: get,
        reset: reset,
    };
    function set(connectedUser) {
        connectedUser = connectedUser;
    }
    function reset() {
        connectedUser = null;
        return null;
    }
    function get() {
        // NOTE: userDetails are memoized and returned as a promise
        let deferred = $q.defer();
        if (connectedUser !== null) {
            // console.log('userDetails from cache');
            deferred.resolve(connectedUser);
            return deferred.promise;
        }
        return UserServiceApi.details().then(function (response) {
            connectedUser = response.data;
            return connectedUser;
        });
    }
    return fac;
});
